export const TINYMCE_API_KEY =
  "23yu2nhfd14k50sn00nth5by39d8ozgzcfjr6xcqev6blcmd";

export const TINYMCE_INIT_SETTINGS = {
  plugins: "link code autolink charmap lists paste",
  toolbar:
    "undo redo | formatselect | paste pastetext | bold italic underline numlist bullist | alignleft aligncenter alignright | charmap link | code",
  height: 300,
};
